package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mohamedrejeb.compose.dnd.DragAndDropState
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalEvent
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalNavigation
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalState
import com.essntl.features.proposal.ui.rememberDayProposalServiceList
import com.essntl.features.proposal.ui.rememberLocalDate
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.uikit.components.button.outline.EsLargeOutlineButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ColumnScope.journeyDays(
    dragAndDropState: DragAndDropState<Pair<ServiceModel, ProposalServiceModel>>,
    isDateValid: Boolean,
    numberOfDays: Int,
    filteredProposalServices: List<ProposalServiceModel>,
    state: AddEditProposalState,
    onEvent: (AddEditProposalEvent) -> Unit,
    onNavigation: (AddEditProposalNavigation) -> Unit,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Start,
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                horizontal = EsConstants.SectionHorizontalPadding,
            )
            .padding(
                top = EsConstants.SectionVerticalPadding,
            ),
    ) {
        EsLargeIcon(
            res = EsIcons.Calendar,
            tint = MaterialTheme.esColorScheme.iconPrimary,
        )

        Spacer(modifier = Modifier.width(1.5.spacing))

        Text(
            text = "Journey days",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.h4SemiBold20,
        )

        Spacer(modifier = Modifier.weight(1f))

        Spacer(modifier = Modifier.width(1.5.spacing))

        if (state.proposal.value.status == ProposalModel.Status.ItineraryReady ||
            state.proposal.value.status == ProposalModel.Status.Confirmed
        ) {
            EsLargeOutlineButton(
                onClick = {
                    state.proposal.value.itineraryId?.let {
                        onNavigation(
                            AddEditProposalNavigation.NavigateToItinerary(itineraryId = it),
                        )
                    }
                },
                text = "Itinerary available",
                loading = state.addEditProposal.isLoading,
                suffixIconRes = EsIcons.Itinerary,
            )
            Spacer(modifier = Modifier.width(1.5.spacing))
        }
    }

    Spacer(modifier = Modifier.height(1.5.spacing))

    if (isDateValid && numberOfDays >= 0) {
        repeat(numberOfDays) { index ->
            val localDate = rememberLocalDate(index, state.proposal.value.fromDate)

            val dayProposalServiceList = rememberDayProposalServiceList(
                localDate,
                filteredProposalServices,
            )

            if (localDate != null) {
                key(localDate.toString()) {
                    JourneyDayRow(
                        state = state,
                        onEvent = onEvent,
                        onNavigation = onNavigation,
                        dragAndDropState = dragAndDropState,
                        index = index,
                        numberOfDays = numberOfDays,
                        localDate = localDate,
                        proposalServiceList = dayProposalServiceList,
                        isTotalOnlyProposal = state.proposal.value.showsTotalOnly == true,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = EsConstants.SectionHorizontalPadding),
                    )
                }

                if (index != numberOfDays)
                    Spacer(modifier = Modifier.height(1.5f.spacing))
            }
        }
    } else {
        Text(
            text = buildAnnotatedString {
                withStyle(
                    style = SpanStyle(
                        color = MaterialTheme.esColorScheme.textTertiary,
                        fontWeight = FontWeight.Normal,
                    ),
                ) {
                    append("Please, ")
                }
                append("enter dates ")
                withStyle(
                    style = SpanStyle(
                        color = MaterialTheme.esColorScheme.textTertiary,
                        fontWeight = FontWeight.Normal,
                    ),
                ) {
                    append("to create the trip")
                }
            },
            textAlign = TextAlign.Center,
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.s2SemiBold16.copy(
                fontSize = 17.sp,
            ),
            modifier = Modifier
                .fillMaxWidth()
                .padding(
                    vertical = 100.dp,
                ),
        )
    }

    Spacer(modifier = Modifier.height(EsConstants.SectionVerticalPadding))
}
